//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import common from "../../../api/common"
export default {
  data() {
    return {
      startDate: new Date(1900,1,1),
      pickerdate:"请选择",
      pickerValue:[],
      sexPickerShow: false,
      sex: "",
      patientname:'',
      relationPickerShow: false,
      relation: "请选择",
      relationColumns: [
        {
          values: [
            {
              name: "本人",
              id: 1
            },
            {
              name: "朋友",
              id: 2
            },
            {
              name: "家属",
              id: 3
            },
            {
              name: "其他",
              id: 4
            }
          ]
        }
      ],
      userInfo: {},
      imageUrl: require("../../../assets/my/mrtx@3x.png"),
    };
  },
  created() {
    document.title="患者信息";
    this.userInfo = this.$store.state.userInfo;
    this.patientname=this.userInfo.patientname?this.userInfo.patientname:'';
    this.sex = this.userInfo.sex == "1" ? "男" : "女";
    this.relation = this.userInfo.relationship;
    this.pickerdate=this.userInfo.birthday?this.userInfo.birthday:'请选择';
    this.imageUrl =
      this.userInfo.portrait == ""
        ? this.userInfo.headphoto == ""
          ? this.imageUrl
          : this.userInfo.headphoto
        : this.userInfo.portrait;
    this.userInfo.oldportrait = this.userInfo.portrait;
    this.orderID = this.$route.query.orderId;
  },
  methods: {
    getSex(index){
      this.sex=index;
    },
    confirmDate(value){
      this.pickerdate=common.timestampToTime(value,2)
    },
    getPicker(){
      this.$refs.datePickers.open();
    },
    updateTop(){
      window.scroll(0,0);
    },
    confirmRelation(picker, value) {
      var _this = this;
      this.$nextTick(() => {
        var relation = picker.getValues();
        _this.relation = relation[0].name;
      });
    },
    sendDoctor() {
      var _this = this;
      if (this.userInfo.oldportrait === this.userInfo.portrait) {
        this.userInfo.oldportrait = "";
      }
      if (!(this.patientname)) {
        this.$toastMsg("请填写姓名");
        return false;
      }
      if (!(this.sex)) {
        this.$toastMsg("请选择性别");
        return false;
      }
      if (!(this.pickerdate)&&this.pickerdate=="请选择") {
        this.$toastMsg("请填写出生日期");
        return false;
      }
      if (this.relation == null || this.relation == ""||this.relation == "请选择") {
        this.$toastMsg("请选择关系");
        return false;
      }
      var newpatient = {
        id: this.userInfo.id,
        patientname: this.patientname,
        portrait: this.userInfo.portrait,
        sex: this.sex == "男" ? "1" : "2",
        birthday:this.pickerdate,
        relationship: this.relation,
        oldportrait: this.userInfo.oldportrait
      };
      this.$doRequest("/api/Personal/addpatient", newpatient, res => {
        _this.$doRequest(
          "/api/Personal/getMyDetial",
          { parameters: _this.userInfo.id },
          res => {
            res.sessionId = _this.userInfo.sessionId;
            _this.$store.state.userInfo = res;
            _this.$toastMsg("添加完成");
            this.$router.push({
              path: "/two",
              query: { orderId: _this.orderID, }
            });
          }
        );
      });
    },
    chooseImg(e) {
      var files = e.target.files[0];
      var formData = new FormData();
      formData.append("file", files);
      var _this = this;
      this.$doRequest(
        "/api/FastDfs/uploadLocal",
        formData,
        res => {
          _this.userInfo.portrait = res[0].fileUrl;
          _this.imageUrl = _this.$store.state.fileUrl + res[0].fileUrl;
        },
        null,
        null,
        true
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/upload/three/three.vue